<template>
  <component
    :is="name"
    :size="size"
  />
</template>
<script>
const Kubernetes = () => import('@/components/icons/Kubernetes.vue')

export default {
  name: 'LogoIcon',
  components: {
    Kubernetes,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: '24',
    },
  },
}
</script>
